
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/locale/ariston",
      function () {
        return require("private-next-pages/locale/ariston.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/locale/ariston"])
      });
    }
  